// COMMERCE_UX1J_EXACT_PRODUCTION_CLIENT_LOCK
//
// Browser calls only the Forfeo Supabase Edge Function.
// No carrier credentials are present here.

import {
  supabase,
} from '../supabaseClient';

export type ForfyShippingLabelPurchaseResponse = {
  ok: boolean;

  error?: string;
  message?: string;

  status?: string;

  transactionId?: string;

  labelUrl?: string;
  labelFileType?: string;

  trackingNumber?: string;
  trackingStatus?: string;
  trackingUrl?: string;

  provider?: string;
  service?: string;

  amount?: string;
  currency?: string;

  purchasedNow?: boolean;
  duplicatePrevented?: boolean;

  safeRetry?: boolean;

  currentAmount?: string;
  currentCurrency?: string;
};

const FUNCTION_NAME =
  'forfy-commerce-shippo-label-purchase';

const clean = (
  value: unknown,
  max = 3000,
) =>
  String(value ?? '')
    .replace(
      /shippo_(live|test)_[A-Za-z0-9_-]+/gi,
      '***SERVER_VALUE_HIDDEN***',
    )
    .slice(0, max);

export const purchaseForfyShippingLabel =
  async (
    input: {
      rateId: string;
      orderReference: string;
      expectedAmount: string;
      expectedCurrency: string;
    },
  ):
  Promise<ForfyShippingLabelPurchaseResponse> => {
    try {
      const {
        data,
        error,
      } =
        await supabase
          .functions
          .invoke(
            FUNCTION_NAME,
            {
              body: {
                ...input,

                confirmPurchase:
                  true,

                confirmationVersion:
                  'ux1j-production-v4',
              },
            },
          );

      if (error) {
        return {
          ok:
            false,

          error:
            'production_purchase_edge_error',

          message:
            clean(
              error.message ||
              'L’achat de l’étiquette n’a pas été confirmé.',
            ),
        };
      }

      return {
        ok:
          data?.ok === true,

        error:
          clean(
            data?.error,
          ),

        message:
          clean(
            data?.message,
          ),

        status:
          clean(
            data?.status,
          ),

        transactionId:
          clean(
            data?.transactionId,
          ),

        labelUrl:
          clean(
            data?.labelUrl,
          ),

        labelFileType:
          clean(
            data?.labelFileType,
          ),

        trackingNumber:
          clean(
            data?.trackingNumber,
          ),

        trackingStatus:
          clean(
            data?.trackingStatus,
          ),

        trackingUrl:
          clean(
            data?.trackingUrl,
          ),

        provider:
          clean(
            data?.provider,
          ),

        service:
          clean(
            data?.service,
          ),

        amount:
          clean(
            data?.amount,
          ),

        currency:
          clean(
            data?.currency,
          ),

        purchasedNow:
          Boolean(
            data?.purchasedNow,
          ),

        duplicatePrevented:
          Boolean(
            data?.duplicatePrevented,
          ),

        safeRetry:
          data?.safeRetry ===
            undefined
            ? undefined
            : Boolean(
                data.safeRetry,
              ),

        currentAmount:
          clean(
            data?.currentAmount,
          ),

        currentCurrency:
          clean(
            data?.currentCurrency,
          ),
      };
    } catch (error) {
      return {
        ok:
          false,

        error:
          'production_purchase_network_error',

        message:
          clean(
            error instanceof Error
              ? error.message
              : 'Erreur réseau pendant l’achat.',
          ),

        safeRetry:
          false,
      };
    }
  };
